import React from "react";
import PropTypes from "prop-types";

const EmptyStateOverlay = ({ message, backdropBlur = "blur(3px)", padding = "0", borderRadius = "0px" }) => {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        top: 0,
        right: 0,
        bottom: 0,
        background: "rgba(255,255,255,0.8)",
        backdropFilter: `saturate(180%) ${backdropBlur}`,
        borderRadius,
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding,
      }}
    >
      <div style={{ position: "relative", zIndex: 2 }}>{message}</div>
    </div>
  );
};

EmptyStateOverlay.propTypes = {
  message: PropTypes.string.isRequired,
  backdropBlur: PropTypes.string,
  padding: PropTypes.string,
};

export default EmptyStateOverlay;
